export default "__VITE_ASSET__L09yo8aq__"